<div class="profile-inner-main-wrapper">
  <div class="details-wrapper">
    <h2>Basic Salary</h2>
    <h3 *ngIf="employeeData?.employeeSalaries?.length > 0">
      {{employeeData?.employeeSalaries[0]?.basicSalary}}
    </h3>
  </div>
  <div class="details-wrapper">
    <h2>House Rent Allowance</h2>
    <h3 *ngIf="employeeData?.employeeSalaries?.length > 0">
      {{employeeData?.employeeSalaries[0]?.hra}}
    </h3>
  </div>
  <div class="details-wrapper">
    <h2>Allowances</h2>
    <h3 *ngIf="employeeData?.employeeSalaries?.length > 0">
      {{employeeData?.employeeSalaries[0]?.allowances}}
    </h3>
  </div>
  <div class="details-wrapper">
    <h2>Deductions</h2>
    <h3 *ngIf="employeeData?.employeeSalaries?.length > 0">
      {{employeeData?.employeeSalaries[0]?.deductions}}
    </h3>
  </div>
  <div class="details-wrapper">
    <h2>Gross Salary</h2>
    <h3 *ngIf="employeeData?.employeeSalaries?.length > 0">
      {{employeeData?.employeeSalaries[0]?.grossSalary}}
    </h3>
  </div>
  <div class="details-wrapper">
    <h2>Net Salary</h2>
    <h3 *ngIf="employeeData?.employeeSalaries?.length > 0">
      {{employeeData?.employeeSalaries[0]?.netSalary}}
    </h3>
  </div>
  <div class="details-wrapper">
    <h2>Current CTC</h2>
    <h3>{{employeeData?.salary}}</h3>
  </div>
</div>
<!-- <div class="details-wrapper">
  <button
    class="cmn-add-btn"
    (click)="addSalaryIncrement()"
    style="margin-left: auto"
  >
    <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Salary
    Increment
  </button>
</div> -->
<!-- <div>
  <ag-grid-angular
    style="width: 100%"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [pagination]="true"
    [paginationPageSize]="paginationPageSize"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    [class]="themeClass"
  />
</div> -->
<!-- <h4>Salary Details</h4>
<div class="salary-container">
  <table class="salary-table">
    <tr>
      <th>Increment Date</th>
      <th>Old Salary</th>
      <th>New Salary</th>
      <th>Increment Allowance</th>
      <th>Increment Basic</th>
    </tr>
    <ng-container *ngIf="rowData.length > 0; else noData">
      <tr *ngFor="let row of rowData">
        <td>{{ row.incrementDate || '--' }}</td>
        <td>{{ formatCurrency(row.oldSalary) || '--'}}</td>
        <td>{{ formatCurrency(row.newSalary) || '--' }}</td>
        <td>{{ formatCurrency(row.incrementAllowance)}}</td>
        <td>{{ formatCurrency(row.incrementBasic) || '--' }}</td>
      </tr>
    </ng-container>
    <ng-template #noData>
      <tr>
        <td colspan="5" class="no-data" style="text-align: center">
          No data available
        </td>
      </tr>
    </ng-template>
  </table>
</div> -->
